module.exports = __webpack_public_path__ + "img/u7565.c72e76b1.svg";